import React from 'react'
import { ColumnMenuOption, DropdownButtonV2 } from '@labrav/react-components'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from '../../../store'
import { clearButtonData } from '../../../modules/storefront/buttonCreation/action'
import { clearListingCardData } from '../../../modules/storefront/listingCardCreation/action'
import { clearAutosaveStatus } from '@labrav/common'
import { getCreateButtonOptions, getCreateNavigation } from '../helpers'

export interface CreateButtonProps {
  handleClick?: () => void
  isLoading?: boolean
}

export const CreateButton: React.FC<CreateButtonProps> = ({ isLoading }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleRoute = async (selected: ColumnMenuOption) => {
    const navigation = getCreateNavigation(selected)
    if (!navigation) {
      return
    }
    if (navigation.clearButton) {
      await dispatch(clearButtonData())
    }
    if (navigation.clearListing) {
      await dispatch(clearListingCardData())
      await dispatch(clearAutosaveStatus())
    }
    navigate(navigation.path)
  }

  return (
    <DropdownButtonV2
      variant="contained"
      styleType="primary"
      buttonText="Create"
      data-testid="create-template-storefront"
      disabled={isLoading}
      options={getCreateButtonOptions()}
      onOptionClick={handleRoute}
    />
  )
}
